import type { SoundClipsLocale } from './en'

export const soundClipsNe = {
  list: {
    title: 'साउन्ड क्लिपहरू',
    loading: 'साउन्ड क्लिपहरू लोड हुँदैछ...',
    error: 'त्रुटि',
    empty: 'कुनै साउन्ड क्लिप फेला परेन',
    emptyDescription:
      'हाल यस पीबीएक्सका लागि कुनै साउन्ड क्लिप कन्फिगर गरिएको छैन।',
    noResults: 'कुनै परिणाम छैन',
    noResultsDescription: 'तपाईंको खोजसँग मिल्ने कुनै साउन्ड क्लिप छैन।',
    columnName: 'नाम',
    columnFeatureCode: 'फिचर कोड',
    columnUpdated: 'अपडेट गरिएको',
    columnActions: 'कार्यहरू',
    featureCodeNone: 'N/A',
    createButton: '+ नयाँ साउन्ड क्लिप',
    deleteConfirmTitle: 'साउन्ड क्लिप मेटाउनुहोस्',
    deleteConfirmMessage:
      'के तपाईं "{{name}}" मेटाउन निश्चित हुनुहुन्छ? यो कार्य पूर्ववत गर्न सकिँदैन।',
    deleteConfirmButton: 'मेटाउनुहोस्',
    deleteSuccess: 'साउन्ड क्लिप मेटाइयो।',
    deleteError: 'साउन्ड क्लिप मेटाउन सकिएन।',
    searchPlaceholder: 'साउन्ड क्लिपहरू खोज्नुहोस्...',
    recordingInfo:
      'नयाँ साउन्ड क्लिप रेकर्ड गर्न आफ्नो फोनबाट *99 डायल गर्नुहोस्। अवस्थित क्लिप पुनः रेकर्ड गर्न *100–*109 डायल गर्नुहोस्।',
    audioLoadError:
      'अडियो लोड गर्न सकिएन — यसलाई पुनः रेकर्ड गर्नुपर्ने हुन सक्छ।',
  },
  create: {
    title: 'नयाँ साउन्ड क्लिप',
    nameLabel: 'नाम',
    namePlaceholder: 'साउन्ड क्लिपको नाम लेख्नुहोस्',
    featureCodeLabel: 'फिचर कोड',
    featureCodeNone: 'कुनै पनि होइन',
    audioFileLabel: 'अडियो फाइल',
    audioFilePlaceholder:
      'यहाँ WAV वा MP3 फाइल तानेर छोड्नुहोस्, वा ब्राउज गर्न क्लिक गर्नुहोस्',
    audioFileAccepted: 'WAV, MP3 (अधिकतम 25 MB)',
    cancel: 'रद्द गर्नुहोस्',
    submit: 'साउन्ड क्लिप अपलोड गर्नुहोस्',
    creating: 'अपलोड हुँदैछ...',
    success: 'साउन्ड क्लिप सफलतापूर्वक सिर्जना गरियो।',
    error: 'साउन्ड क्लिप सिर्जना गर्न सकिएन।',
    nameRequired: 'नाम आवश्यक छ।',
    audioFileRequired: 'अडियो फाइल आवश्यक छ।',
  },
  edit: {
    title: 'साउन्ड क्लिप सम्पादन गर्नुहोस्',
    loading: 'साउन्ड क्लिप लोड हुँदैछ...',
    notFound: 'साउन्ड क्लिप फेला परेन।',
    backToList: '← सूचीमा फर्कनुहोस्',
    nameLabel: 'नाम',
    namePlaceholder: 'साउन्ड क्लिपको नाम लेख्नुहोस्',
    featureCodeLabel: 'फिचर कोड',
    featureCodeNone: 'कुनै पनि होइन',
    audioFileLabel: 'अडियो फाइल बदल्नुहोस्',
    audioFilePlaceholder:
      'बदल्नका लागि नयाँ फाइल तानेर छोड्नुहोस्, वा ब्राउज गर्न क्लिक गर्नुहोस्',
    audioFileAccepted: 'WAV, MP3 (अधिकतम 25 MB)',
    currentAudio: 'हालको अडियो',
    playCurrentAudio: 'हालको अडियो बजाउनुहोस्',
    stopAudio: 'रोक्नुहोस्',
    audioLoadError:
      'यस क्लिपको अडियो लोड गर्न सकिएन — यसलाई पुनः रेकर्ड गर्नुपर्ने हुन सक्छ।',
    createdLabel: 'सिर्जना गरिएको',
    updatedLabel: 'पछिल्लो अपडेट',
    cancel: 'रद्द गर्नुहोस्',
    submit: 'परिवर्तनहरू सेभ गर्नुहोस्',
    saving: 'सेभ हुँदैछ...',
    success: 'साउन्ड क्लिप सफलतापूर्वक अपडेट गरियो।',
    error: 'साउन्ड क्लिप अपडेट गर्न सकिएन।',
    deleteButton: 'साउन्ड क्लिप मेटाउनुहोस्',
  },
  upload: {
    invalidType: 'असमर्थित फाइल प्रकार। कृपया WAV वा MP3 अपलोड गर्नुहोस्।',
    tooLarge: 'फाइल धेरै ठूलो छ। अधिकतम आकार 25 MB हो।',
  },
} satisfies SoundClipsLocale
